"use client";
import Flex from "@/components/core/flex";
import { Link } from "@/i18n/routing";
import { cn } from "@/lib/utils/utils";
export default function HeaderLink({
  className,
  href,
  icon,
  title,
}: {
  className?: string;
  href: string;
  icon: React.ReactNode;
  title?: string;
}) {
  return (
    <Link href={href} aria-label={title || href}>
      <div
        className={cn(
          "relative w-10 h-10 bg-primary/20 flex items-center justify-center rounded-full  hover:text-primary-foreground transition-all duration-300 ease-linear  hover:[&>div]:h-full overflow-hidden",
          className,
        )}
      >
        <div className="h-0 w-full bg-primary rounded-full absolute z-0  top-0 bottom-0 transition-all duration-300 ease-linear" />
        <Flex
          className="z-20 w-full h-full relative"
          justify="center"
          items="center"
        >
          {icon}
        </Flex>
      </div>
    </Link>
  );
}
